<script setup lang="ts">
import { ref, computed } from 'vue'
import { navigationStore } from '@/components/navigationPaneV2/store/navigationStore'

const props = withDefaults(
  defineProps<{
    nav?: boolean
  }>(),
  {
    nav: true
  }
)

const isMobileNavBar = computed(() => navigationStore.state.isMobile)
</script>

<template>
  <div
    class="bg-primary2 flex h-dvh w-screen flex-col"
    :class="{
      'pb-[50px]': nav && isMobileNavBar,
      'pb-0 pl-16': nav && !isMobileNavBar
    }"
  >
    <slot name="header" />

    <div class="flex-grow overflow-x-hidden overflow-y-auto">
      <slot />
    </div>
  </div>
</template>
